import {observer} from 'mobx-react-lite'
import {ManualPromise} from '@oc/utils'
import {OcSimpleConfirmDialog} from './OcSimpleConfirmDialog'
import {DataCyProps} from './dataCyProps'

interface ConfirmActionDialogProps extends DataCyProps {
    title: string
    confirmPromise: ManualPromise<void, any> | undefined | null
}

function _ConfirmActionDialog(props: ConfirmActionDialogProps) {
    if (!props.confirmPromise) {
        return null
    }

    return (
        <OcSimpleConfirmDialog
            square
            open={!!props.confirmPromise}
            title={props.title}
            content={props.confirmPromise.data}
            confirm={props.confirmPromise.resolve}
            cancel={props.confirmPromise.reject}
            data-cy={props['data-cy']}
        />
    )
}
/**
 * Simple dialog which handles manual promise.
 *
 * Dialog is shown as long as `confirmPromise` is defined and it uses its `ManualPromise.data` as a content.
 */
export const ConfirmActionDialog = observer(_ConfirmActionDialog)
